import React from 'react';

const newIconStyle = {
  color: 'var(--primary)',
  enableBackground: 'new 0 0 490.688 490.688',
  marginTop: -2,
  width: 20,
};
const NewIcon = props => <svg {...props} className={`${props.className}`} x="0px" y="0px" viewBox="0 0 490.688 490.688" style={newIconStyle} xmlSpace="preserve">
  <path fill="currentColor" d="M462.784,209.088c-7.552-5.568-17.067-12.523-18.219-17.067c0.484-8.796,2.996-17.36,7.339-25.024
	c6.656-15.275,13.525-31.104,5.888-44.267c-7.637-13.163-25.003-15.296-41.707-17.067c-8.658-0.058-17.188-2.094-24.939-5.952
	c-3.864-7.778-5.893-16.339-5.931-25.024c-1.877-16.704-3.819-33.984-17.067-41.707c-13.248-7.723-29.099-0.96-44.373,5.781
	c-7.672,4.341-16.243,6.852-25.045,7.339c-4.608-1.237-11.541-10.667-17.067-18.219c-9.685-13.056-20.587-27.861-36.331-27.861
	s-26.645,14.805-36.267,27.861c-5.589,7.573-12.523,17.067-17.067,18.24c-8.794-0.53-17.356-3.038-25.045-7.339
	c-15.36-6.763-31.189-13.504-44.309-5.909s-15.317,25.003-17.195,41.813c-0.061,8.655-2.089,17.183-5.931,24.939
	c-7.736,3.803-16.233,5.801-24.853,5.845c-16.725,1.877-34.027,3.819-41.728,17.067S32,151.616,38.741,166.912
	c4.357,7.689,6.869,16.284,7.339,25.109c-1.237,4.608-10.667,11.563-18.219,17.067C14.805,218.688,0,229.611,0,245.355
	s14.805,26.667,27.883,36.267c7.552,5.568,17.067,12.523,18.219,17.067c-0.484,8.796-2.996,17.36-7.339,25.024
	c-6.656,15.275-13.525,31.104-5.888,44.267c7.637,13.163,25.003,15.296,41.707,17.067c8.658,0.058,17.188,2.094,24.939,5.952
	c3.864,7.778,5.893,16.339,5.931,25.024c1.877,16.704,3.819,33.984,17.067,41.707c13.248,7.723,28.971,0.768,44.267-5.888
	c7.749-4.293,16.37-6.773,25.216-7.253c4.608,1.237,11.541,10.667,17.067,18.219c9.621,13.056,20.523,27.861,36.267,27.861
	s26.645-14.805,36.267-27.861c5.589-7.573,12.523-17.067,17.067-18.24c8.8,0.498,17.368,3.008,25.045,7.339
	c15.275,6.656,31.104,13.483,44.245,5.909c13.141-7.573,15.317-25.003,17.195-41.728c0.061-8.655,2.089-17.183,5.931-24.939
	c7.75-3.834,16.271-5.855,24.917-5.909c16.725-1.877,34.027-3.819,41.728-17.067c7.701-13.248,0.747-28.971-5.888-44.267
	c-4.343-7.728-6.826-16.362-7.253-25.216c1.237-4.608,10.667-11.563,18.219-17.067c13.056-9.621,27.883-20.544,27.883-36.267
	S475.861,218.688,462.784,209.088z"/>
  <g>
    <path fill="#FAFAFA" d="M181.333,298.688c-3.357,0-6.519-1.581-8.533-4.267L128,234.688v53.333
		c0,5.891-4.776,10.667-10.667,10.667s-10.667-4.776-10.667-10.667v-85.333c0-5.891,4.776-10.667,10.667-10.667
		c3.357,0,6.519,1.581,8.533,4.267l44.8,59.733v-53.333c0-5.891,4.776-10.667,10.667-10.667c5.891,0,10.667,4.776,10.667,10.667
		v85.333c-0.003,4.589-2.942,8.662-7.296,10.112C183.618,298.501,182.48,298.688,181.333,298.688z"/>
    <path fill="#FAFAFA" d="M266.667,298.688H224c-5.891,0-10.667-4.776-10.667-10.667v-85.333
		c0-5.891,4.776-10.667,10.667-10.667h42.667c5.891,0,10.667,4.776,10.667,10.667c0,5.891-4.776,10.667-10.667,10.667h-32v64h32
		c5.891,0,10.667,4.776,10.667,10.667S272.558,298.688,266.667,298.688z"/>
    <path fill="#FAFAFA" d="M266.667,256.021H224c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667h42.667
		c5.891,0,10.667,4.776,10.667,10.667S272.558,256.021,266.667,256.021z"/>
    <path fill="#FAFAFA" d="M373.333,298.688c-4.597,0.006-8.681-2.934-10.133-7.296L352,257.749l-11.2,33.643
		c-1.363,4.603-5.751,7.633-10.539,7.275c-4.738-0.18-8.788-3.465-9.941-8.064l-21.333-85.333
		c-1.426-5.72,2.056-11.513,7.776-12.939c5.72-1.426,11.513,2.056,12.939,7.776l12.437,49.792l9.749-29.248
		c2.535-5.591,9.122-8.068,14.713-5.533c2.454,1.113,4.42,3.079,5.533,5.533l9.749,29.248l12.437-49.792
		c1.426-5.72,7.218-9.202,12.939-7.776c5.72,1.426,9.202,7.218,7.776,12.939l-21.333,85.333c-1.153,4.599-5.204,7.884-9.941,8.064
		L373.333,298.688z"/>
  </g>
</svg>;

export default NewIcon;
